import { render, staticRenderFns } from "./header-primary-menu-mobile.vue?vue&type=template&id=584a06a2"
import script from "./header-primary-menu-mobile.vue?vue&type=script&lang=js"
export * from "./header-primary-menu-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports